export default __webpack_public_path__ + "static/media/jojo.7e2984ea.jpg";